import React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import LockIcon from "@mui/icons-material/Lock";
import HomeIcon from "@mui/icons-material/Home";

const ForbiddenPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => { navigate("/dashboard");};

  const handleGoBack = () => { navigate(-1);};

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        bgcolor: "#000",
        padding: 3,
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          maxWidth: 500,
          bgcolor: "#1e1e1e",
          padding: 4,
          borderRadius: 2,
          boxShadow: 3,
          border: "1px solid #333",
        }}
      >
        <LockIcon
          sx={{
            fontSize: 80,
            color: "hsl(19 101% 51% / 1)",
            mb: 2,
          }}
        />
        
        <Typography variant="h3" component="h1" gutterBottom fontWeight="bold" color="hsl(19 101% 51% / 1)">
          403
        </Typography>
        
        <Typography variant="h5" component="h2" gutterBottom color="#fff">
          Access Denied
        </Typography>
        
        <Typography variant="body1" sx={{ mb: 4, color: "#aaa" }}>
          You don't have permission to access this resource. If you believe this is an error, please contact your administrator.
        </Typography>

        <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
          <Button
            variant="outlined"
            startIcon={<HomeIcon />}
            onClick={handleGoBack}
            sx={{
              borderColor: "hsl(19 101% 51% / 1)",
              color: "hsl(19 101% 51% / 1)",
              "&:hover": {
                borderColor: "hsl(19 101% 41% / 1)",
                bgcolor: "rgba(255, 255, 255, 0.04)",
              },
            }}
          >
            Go Back
          </Button>
          
          <Button
            variant="contained"
            startIcon={<HomeIcon />}
            onClick={handleGoHome}
            sx={{
              bgcolor: "hsl(19 101% 51% / 1)",
              "&:hover": {
                bgcolor: "hsl(19 101% 41% / 1)",
              },
            }}
          >
            Go to Dashboard
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ForbiddenPage;
